import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Convierte un teléfono al formato que requiere wa.me para encontrar la
// cuenta de WhatsApp correctamente. Acepta +, espacios, paréntesis y guiones.
// Para México, WhatsApp dejó de requerir el "1" extra tras la lada 52:
// el formato vigente es 52 + 10 dígitos (NO 521 + 10 dígitos).
export function toWhatsAppNumber(phone) {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return "";

  // Formato móvil mexicano antiguo (52 + 1 + 10 dígitos, 13 dígitos) -> se
  // quita el "1" extra y se deja 52 + 10 dígitos (formato vigente).
  if (digits.length === 13 && digits.startsWith("521")) return `52${digits.slice(3)}`;
  // Ya viene con la lada de México correcta (52 + 10 dígitos, 12 dígitos).
  if (digits.length === 12 && digits.startsWith("52")) return digits;
  // 10 dígitos locales de México (sin lada) -> se antepone 52.
  if (digits.length === 10) return `52${digits}`;

  // Números internacionales (no mexicanos) u otros formatos: no se truncan
  // ni se modifican, se dejan tal cual si su longitud es la de un teléfono
  // real (E.164: entre 7 y 15 dígitos). Si no, se descarta de forma segura.
  if (digits.length >= 7 && digits.length <= 15) return digits;
  return "";
}
